<template>
  <model-table
    :collection="locationGroups"
    :orderable="true"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { label: 'Printer', field: 'resolvedPrinter', component: 'model' },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
    :has-library="!currentCircuit.isLibrary"
    :library-collection="locationGroupLibrary"
    :library-columns="[
      { field: 'name' },
    ]"
    :link-filter="libraryFilterFunction"
  >
    <location-group-form />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import LocationGroupForm from 'src/modules/admin/location/LocationGroupForm'

export default {
  name: 'LocationTable',
  components: {
    ModelTable,
    LocationGroupForm
  },
  configuration: ['currentCircuit'],
  models: {
    locationGroups: {
      printer: {
        fields: ['id', 'name']
      },
      kitchenDisplay: {
        fields: ['id', 'name']
      },
      registerStation: {
        fields: ['id', 'name']
      },
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    locationGroupLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
